import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { pega_renovacao_serie_unidade } from "../../services/api";
import './tabelas_matricula.css';

const Fidelizacao_serie_unidade = (props) => {
    const [dataTotal2, setDataTotal2] = useState([]);
    const [isloading, setIsloading] = useState(true);

    const fetchData = async () => {
        try {
            const response = await pega_renovacao_serie_unidade(props.di, props.df);
            setDataTotal2(response || []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsloading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [props.di, props.df]);

    const convertSegmento = (seg) => {
        const labels = {
            '0-1': 'Mat 1', '0-2': 'Mat 2', '0-3': 'Pré 1', '0-4': 'Pré 2',
            '1-1': '1º Fund I', '1-2': '2º Fund I', '1-3': '3º Fund I', '1-4': '4º Fund I', '1-5': '5º Fund I',
            '1-6': '6º Fund II', '1-7': '7º Fund II', '1-8': '8º Fund II', '1-9': '9º Fund II',
            '2-1': '1ª Médio', '2-2': '2ª Médio', '2-3': '3ª Médio'
        };
        return labels[seg] || seg;
    };

    // Regra de cores de fidelização
    const getRetentionClass = (val) => {
        if (val < 25) return "bg-black";
        if (val < 40) return "bg-darkred";
        if (val < 50) return "bg-red";
        if (val < 75) return "bg-orange";
        return "bg-green";
    };

    const unidadesColunas = ['smre', 'bt', 'br', 'cg', 'cd', 'fg', 'ig', 'md', 'mc', 'np', 'rb', 'sc', 'sp', 'tq'];

    return (
        <div className="mt-3">
            <div className="table-responsive shadow-sm rounded border">
                <Table hover bordered className="text-center align-middle bg-white m-0 tabela-matriculas" style={{ fontSize: '0.8rem' }}>
                    <thead className="table-dark">
                        <tr>
                            <th className="text-start ps-2">SEGMENTO</th>
                            <th>REDE</th>
                            <th>BT</th><th>BR</th><th>CG</th><th>CD</th>
                            <th>FG</th><th>IG</th><th>MD</th><th>MC</th>
                            <th>NP</th><th>RB</th><th>SC</th><th>SP</th><th>TQ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isloading ? (
                            <tr><td colSpan="15" className="py-4 text-muted">Carregando dados...</td></tr>
                        ) : (
                            dataTotal2.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="text-start fw-bold bg-light ps-2 text-nowrap">
                                        {convertSegmento(item.segmento)}
                                    </td>
                                    {/* Mapeia dinamicamente as colunas das unidades */}
                                    {unidadesColunas.map((colKey, colIdx) => {
                                        const valor = parseFloat(item[colKey]) || 0;
                                        return (
                                            <td key={colIdx} className={getRetentionClass(valor)}>
                                                {valor.toFixed(1)}%
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default Fidelizacao_serie_unidade;